import React from 'react';

import { omit } from 'utils/objectUtils';

import QwertyKeyboard from './QwertyKeyboard';
import type { KeyboardComponentProps } from 'components/Keyboard/types';
import JapaneseImeKeyboard from './JapaneseImeKeyboard';

/**
 * Orchestrates the Japanese language keyboard: either the native IME keyboard
 * (Kana / ABC / ☆123 panels with candidates) or a full-frame QWERTY keyboard.
 * The globe key toggles between the two; the choice is not persisted (reopening
 * the keyboard always starts on the Japanese keyboard).
 */
const JapaneseKeyboard: React.FC<KeyboardComponentProps> = (props) => {
  const [isQwerty, setIsQwerty] = React.useState(false);

  const toggle = React.useCallback(() => setIsQwerty((current) => !current), []);

  return (
    <React.Fragment>
      {isQwerty && (
        <QwertyKeyboard {...omit(props, 'layoutType', 'layoutCandidates')} onToggle={toggle} />
      )}
      {!isQwerty && <JapaneseImeKeyboard {...props} onToggle={toggle} />}
    </React.Fragment>
  );
};

export default JapaneseKeyboard;
